var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-box"},[_c('div',{staticClass:"tips-area text-center"},[_vm._m(0),_c('div',{staticClass:"tips-area__msg"},[_vm._v("\n            批量发布项目成功\n        ")]),_c('div',{staticClass:"tips-area__footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.goPage(
                        `/index/project`
                    )}}},[_vm._v("查看")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips-area__icon"},[_c('i',{staticClass:"el-icon-check"})])
}]

export { render, staticRenderFns }